import React from 'react';
import { Header, List, Message } from 'semantic-ui-react';
import type { RidershipDailyPipelineStatus } from '../../../types/ridershipReadinessTypes';

interface Props {
    daily: RidershipDailyPipelineStatus;
}

const DailyPipelinePanel: React.FC<Props> = ({ daily }) => (
    <div>
        <Header as="h3">Daily APC files (Ridecheck)</Header>
        <p style={{ color: 'rgba(0,0,0,.7)' }}>
            These daily CSV uploads feed the stop-level reports and the Boarding Summary map.
        </p>
        <List bulleted>
            <List.Item>
                Latest file date in storage: {daily.lastBlobServiceDate ?? '—'}
            </List.Item>
            <List.Item>
                Latest date processed in Databricks: {daily.lastDeltaServiceDate ?? '—'}
            </List.Item>
            <List.Item>
                Range checked: {daily.dailyFrom} to {daily.dailyTo}
            </List.Item>
        </List>
        {daily.gaps.length > 0 && (
            <Message warning>
                <Message.Header>Recent day issues</Message.Header>
                <List>
                    {daily.gaps.map(gap => (
                        <List.Item key={`${gap.serviceDate}-${gap.code}`}>
                            <strong>{gap.serviceDate}</strong>: {gap.message}
                        </List.Item>
                    ))}
                </List>
            </Message>
        )}
    </div>
);

export default DailyPipelinePanel;
